/*
|--------------------------------------------------------------------------
| Dependency Definitions
|--------------------------------------------------------------------------
*/

require('../bootstrap');

require('alpinejs');

import Vue from 'vue';



/*
|--------------------------------------------------------------------------
| Global Components
|--------------------------------------------------------------------------
*/

Vue.component('like-product', require('./components/LikeProduct').default);
Vue.component('spare-parts', require('./components/SpareParts').default);
Vue.component('search-spare-parts', require('./components/SearchSpareParts').default);
Vue.component('search', require('../search/Search').default);
Vue.component('add-product', require('../requests/components/AddProduct').default);
Vue.component('customer-price', require('./components/CustomerPrice').default);
Vue.component('internal-information', require('./components/InternalInformation').default);
Vue.component('freight-cost-calculator', require('./components/FreightCostCalculator').default);



/*
|--------------------------------------------------------------------------
| Application
|--------------------------------------------------------------------------
*/

let app = new Vue({
  el: '#app-root',

  created() {
    this.$root.$on('searchIsActive', (value) => {
      this.hasSearch = value;
    });
  },

  data() {
    return {
      hasSearch: false
    }
  },
});